import type { ExtendedMacheteViewer } from 'src/modules/designStudio/helpers/machete/index';

export const macheteViewerRef: { current: null | ExtendedMacheteViewer } = {
  current: null,
};
